export const actions = {
  onClickSignOutAction: "ACCOUNT_MENU_ON_CLICK_SIGN_OUT_ACTION",
};

export const dispatchers = {
  handleOnClickSignOutAction: () => ({
    type: actions.onClickSignOutAction,
  }),
};
